import { createFeature, createReducer, on } from "@ngrx/store";
import { CommissionMatrixModel } from "@shared/data-access/models";
import { CommissionMatrixAction } from "../actions";

export const featureName = 'commissionMatrix';

export interface DataState {
  item:CommissionMatrixModel | null;

}
export const initialState:DataState = {
  item: null
};
export const commissionMatrixFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(CommissionMatrixAction.getDetail,  (state, prop:{item:CommissionMatrixModel}) => ({ ...state, item: prop.item})),

  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = commissionMatrixFeature;
